import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const generateCountDownLabel = _ref => {
  let {
    days,
    hours,
    minutes,
    limitMinutes
  } = _ref;
  if (days > 0) {
    const dayText = days === 1 ? "day" : "days";
    if (hours === 0) {
      return `${days} ${dayText}`;
    }
    const hourText = hours === 1 ? "hour" : "hours";
    return `${days} ${dayText}, ${hours} ${hourText}`;
  } else if (hours > 0) {
    const hourText = hours === 1 ? "hour" : "hours";
    if (minutes === 0) {
      return `${hours} ${hourText}`;
    }
    const minuteText = minutes === 1 ? "minute" : "minutes";
    return `${hours} ${hourText}, ${minutes} ${minuteText}`;
  } else if (minutes >= limitMinutes && minutes > 0) {
    const minuteText = minutes === 1 ? "minute" : "minutes";
    return `${minutes} ${minuteText}`;
  } else if (minutes > 0) {
    return "in a few minutes";
  } else {
    return "in less than a minute";
  }
};
export const StakingCountDownLabel = _ref2 => {
  let {
    label = "Staking begins in",
    timeLeft,
    limitMinutes = 3,
    isRoundView = false
  } = _ref2;
  if (timeLeft.totalMilliseconds <= 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: ` text-white bg-[#22635A] font-sans text-lg font-medium flex flex-row items-center gap-1 ${isRoundView ? "rounded-2xl px-4 py-1" : "xl:flex-col py-4 px-8 rounded-2xl"}`,
    children: [/*#__PURE__*/_jsx("div", {
      className: "whitespace-nowrap",
      children: label
    }), /*#__PURE__*/_jsx("div", {
      className: "whitespace-nowrap",
      children: generateCountDownLabel({
        ...timeLeft,
        limitMinutes
      })
    })]
  });
};